import React from 'react';

const AttendanceLogShow = ({ data }) => {
  return (
    <div>
      <p><strong>Request:</strong> {JSON.stringify(data?.request_payload)}</p>
      <p><strong>Response:</strong> {JSON.stringify(data?.response_payload, null, 2)}</p>
    </div>
  );
};

export default AttendanceLogShow;